import imageCompression from "browser-image-compression"
import { extractTypeAndDate } from 'utils/image'
import { issueUploadUrl, registerImageRecord, uploadFile } from "utils/httpApi"
import { AxiosProgressEvent } from "axios"
import { Buffer } from 'buffer'
import { toast } from "react-toastify"

export const upload = async (
  inputFiles: FileList,
  onUpload: (ev: AxiosProgressEvent) => void,
  onCompleteUploadEach: (idx: number) => void,
  onCompleteUploadAll: Function
) => {
  let uploaededFileName = []

  for (let i = 0; i < inputFiles.length; i++) {
    const f = inputFiles.item(i)
    if (!f) return

    let savedFile = f
    let reductionFile = f



    if (f.type === 'image/jpeg') {
      savedFile = await imageCompression(f, {
        maxWidthOrHeight: 1920,
        initialQuality: 0.8,
        preserveExif: false
      })

      reductionFile = await imageCompression(f, {
        maxWidthOrHeight: 480,
        initialQuality: 0.8,
        preserveExif: false
      })
    }

    const metainfo = await extractTypeAndDate(f)

    const b64Str = Buffer.from('runtak:takumatomoko').toString('base64')
    const authorizationHeaderValue = 'Basic ' + b64Str
    const uploadUrlObj = await issueUploadUrl(metainfo.mediaType, authorizationHeaderValue)
    uploaededFileName.push(uploadUrlObj.filename)

    await uploadFile(savedFile as File, uploadUrlObj.url, f.type, onUpload)
    if (f.type === 'image/jpeg') await uploadFile(reductionFile as File, uploadUrlObj.reductionUrl, f.type, onUpload)
    registerImageRecord(uploadUrlObj.filename, metainfo.originalDate.getTime(), metainfo.mediaType)
    onCompleteUploadEach(i)
  }

  onCompleteUploadAll()
  return uploaededFileName
}